import { Injectable, signal } from '@angular/core';

export interface ImageViewerConfig {
  url: string;
  title?: string;
  subtitle?: string;
}

@Injectable({ providedIn: 'root' })
export class ImageViewerService {
  /** Configuración actual de la imagen a mostrar */
  readonly config = signal<ImageViewerConfig | null>(null);

  /** Indica si el visor está visible */
  readonly isOpen = signal(false);

  /**
   * Abre el visor de imágenes con la configuración dada.
   * @param url      URL de la imagen a mostrar
   * @param title    Título opcional (nombre del elemento)
   * @param subtitle Subtítulo opcional (descripción extra)
   */
  open(url: string, title?: string, subtitle?: string): void {
    if (!url) return;
    this.config.set({ url, title, subtitle });
    this.isOpen.set(true);
  }

  /** Cierra el visor y limpia la configuración */
  close(): void {
    this.isOpen.set(false);
    // Pequeño delay para respetar la animación de cierre
    setTimeout(() => this.config.set(null), 300);
  }
}
